export default "<div class=\"form-modal\">\n\t<app-form #childForm [formData]=\"modalFormData\" [modeType]=\"modeType\" ></app-form>\n</div>\n"